import styled from 'styled-components';

export const NameRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const UserName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Avatar = styled.div`
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  background: #d8d8d8;
  margin-right: 1rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NameTxt = styled.span`
  font-size: 1.4rem;
`;
export const ReviewBlock = styled.div`
  padding: 2rem 0;
  // border-bottom: 1px solid #e5e5e5;
`;
export const ReviewContent = styled.div`
  padding: 1rem 0;
  display: flex;
  flexwrap: wrap;
  font-size: 1.2rem;
  line-height: 1.2;
  color: black;
`;
export const LikeContent = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  padding: 1rem 0;
  .likeTxt {
    color: #18a160;
  }
  .keyTxt {
    color: #647a97;
  }
`;
export const OperatorRespBlock = styled.aside`
  padding-top: 1rem;
`;
export const OpLink = styled.a`
  font-size: 1.2rem;
  color: #2276e3;
`;
export const OpRespBlock = styled.div`
  border-radius: 0.4rem;
  background: #eff3f8;
  padding: 1rem;
  width: 100%;
  p {
    font-size: 1.2rem;
    color: #777;
    padding: 0.3rem 0;
  }
`;
export const ReviewDate = styled.span`
  color: #777;
  font-size: 1.2rem;
  padding-left: 1rem;
`;
export const RatingWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
